<div class="custom-scrollbar-css">
  <h2 class="modal-title"
  style="margin-top: 3%; margin-left: 65px; font-weight: bold">
    Modifier un utilisateur: {{name}} ID-{{id}} </h2>
    <hr style="
  border: 1px solid #262756;
  opacity: 0.23;
  width: 87%;
  " />
  <ngx-spinner *ngIf="updateusercompany==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
    type="ball-clip-rotate-multiple" [fullScreen]="false">
    <p style="color: white"> </p>
  </ngx-spinner>
  <div class="container-fluid mt-3">
    <div class="row    ">
      <div class="col-md-5 w-100" style="margin-left: 4%;" [formGroup]="registerForm" (submit)="submitForm()">
        <h1 class="p-2">
          Nom de compte
        </h1>
        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Nom de compte </mat-label>
          <input [(ngModel)]="username" formControlName="username" #input matInput placeholder="" class="inputModal"
            [errorStateMatcher]="matcher" required>
          <mat-error *ngIf="registerForm.controls['username'].invalid" class="elhoo_compte_messageErrorPositionModal">
            Nom de compte is <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>E-Mail</mat-label>
          <input [(ngModel)]="email" matInput formControlName="email" matInput placeholder="" class="inputModal"
            [errorStateMatcher]="matcher">
            <mat-icon matSuffix>alternate_email</mat-icon>
          <mat-error *ngIf="registerForm.get('email').hasError('email')">Veuillez saisir une format valide !
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-1 col-md-1"></div>
      <div class="col-md-5 w-100" [formGroup]="registerForm" (submit)="submitForm()">
        <h1 class="p-2">
          Informations sur contact</h1>
        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Prénom</mat-label>
          <input [(ngModel)]="first_name" matInput formControlName="first_name" placeholder="" class="inputModal"
            [errorStateMatcher]="matcher">
          <mat-error *ngIf="registerForm.get('first_name').hasError('pattern')">
            Veuillez saisir une format valide !
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Nom</mat-label>
          <input [(ngModel)]="last_name" matInput formControlName="last_name" class="inputModal"
            [errorStateMatcher]="matcher" required>
          <mat-error *ngIf="registerForm.get('last_name').hasError('required')">
            Nom est <strong>obligatoire</strong>
          </mat-error>
          <mat-error *ngIf="registerForm.get('last_name').hasError('pattern')">
            Veuillez saisir une format valide !
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Téléphone</mat-label>
          <input [(ngModel)]="gsm_number" type="text" matInput formControlName="gsm_number" placeholder=""
           [errorStateMatcher]="matcher">
            <mat-icon matSuffix>perm_phone_msg</mat-icon>
          <mat-error *ngIf="registerForm.get('gsm_number').hasError('pattern')">Veuillez saisir une format valide !
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-5 w-100" style="margin-left: 4%;" [formGroup]="registerForm">
        <h1 class="p-2">
          Localisation</h1>
        <mat-form-field appearance="fill" class="w-100 mb-3">
          <mat-label>Sélectionner Pays </mat-label>
          <mat-select formControlName="country" [(ngModel)]="country" class="inputModal"
            (selectionChange)="onChangeCountry($event)">
            <mat-option *ngFor="let country of countryInfo; let i = index" [value]="i">
              {{country.CountryName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100 mb-3">
          <mat-label>Sélectionner Ville</mat-label>
          <mat-select formControlName="city" [(ngModel)]="city" class="inputModal">
            <mat-option *ngFor="let state of stateInfo; let j = index" [value]="j">{{state.StateName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100 mb-3">
          <mat-label>Sélectionner Langue</mat-label>
          <mat-select formControlName="lang" [(ngModel)]="lang" disableRipple class="inputModal">
            <mat-option [value]="0">Francais</mat-option>
            <mat-option [value]="1">Anglais</mat-option>
            <mat-option [value]="2">Espagnol</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-1 col-md-1"></div>
      <div class="col-md-4 w-100 d-none">
        <h1 class="p-2   ">
          Droits disponibles pour l'administrateur</h1>
        <section class="example-section">
          <span class="example-list-section">
            <mat-checkbox class="example-margin" [checked]="allComplete" [indeterminate]="someComplete()"
              (change)="setAll($event.checked)">
              {{task.name}}
            </mat-checkbox>
          </span>
          <span class="example-list-section">
            <ul>
              <li *ngFor="let subtask of task.subtasks">
                <mat-checkbox [(ngModel)]="subtask.completed" [color]="subtask.color"
                  (ngModelChange)="updateAllComplete()">
                  {{subtask.name}}
                </mat-checkbox>
              </li>
            </ul>
          </span>
        </section>
      </div>
      <div class="col-md-4 w-100 d-none">
        <h1 class="p-2">
          Droits disponibles pour l'utilisateur</h1>
        <section class="example-section">
          <span class="example-list-section">
            <mat-checkbox class="example-margin" [checked]="" [indeterminate]="someComplete()"
              (change)="setAll($event.checked)">
              {{task.name}}
            </mat-checkbox>
          </span>
          <span class="example-list-section">
            <ul>
              <li *ngFor="let subtask of task.subtasks">
                <mat-checkbox [(ngModel)]="subtask.completed" [color]="subtask.color"
                  (ngModelChange)="updateAllComplete()">
                  {{subtask.name}}
                </mat-checkbox>
              </li>
            </ul>
          </span>
        </section>
      </div>
      <div class="col-md-4 w-100 d-none">
        <h1 class="p-2">
          Droits disponibles pour report</h1>
        <section class="example-section">
          <span class="example-list-section">
            <mat-checkbox class="example-margin" [checked]="allComplete" [indeterminate]="someComplete()"
              (change)="setAll($event.checked)">
              {{task.name}}
            </mat-checkbox>
          </span>
          <span class="example-list-section">
            <ul>
              <li *ngFor="let subtask of task.subtasks">
                <mat-checkbox [(ngModel)]="subtask.completed" [color]="subtask.color"
                  (ngModelChange)="updateAllComplete()">
                  {{subtask.name}}
                </mat-checkbox>
              </li>
            </ul>
          </span>
        </section>
      </div>
      <div class="col-md-5 w-100" [formGroup]="registerForm" (submit)="submitForm()">
        <h1 class="p-2">
          Mot de passe</h1>
        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Mot de passe</mat-label>
          <input #motdepasseajouter  minlength="10" maxlength="15" matInput formControlName="password" [type]="hide ? 'password' : 'text'"  laceholder="***************"
            class="inputModal" [errorStateMatcher]="matcher" >
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-hint align="start" style="color: green;">Mot de passe entre 10 et 15 caractères</mat-hint>
          <mat-hint align="end" style="color: green;">{{motdepasseajouter.value.length}} / 15</mat-hint>
          <mat-error *ngIf="registerForm.controls['password'].invalid" class="elhoo_compte_messageErrorPositionModal">
            Mot de passe is <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Confirmation du mot de passe</mat-label>
          <input minlength="10" maxlength="15" formControlName="passwordConfirm" laceholder="***************" class="inputModal" [errorStateMatcher]="matcher"
            [type]="hide2 ? 'password' : 'text'" matInput >
          <button mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide2">
            <mat-icon>{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="registerForm.get('passwordConfirm').hasError('required')">Confirmation du mot de passe is
            <strong>obligatoire</strong>
          </mat-error>
          <mat-error *ngIf="registerForm.get('passwordConfirm').hasError('confirmedValidator')" class="error-txt">Les
            mots de passe doivent être identiques.</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-5 w-100" style="margin-left: 4%;" [formGroup]="registerForm">
        <h1 class="p-2">
          Accès</h1>
        <mat-form-field color="accent" appearance="fill" class="w-100 mb-3">
          <mat-label>Date d'expiration</mat-label>
          <input matInput [(ngModel)]="expiration_date" [matDatepicker]="picker1" formControlName="expiration_date">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <div [formGroup]="registerForm" aria-label="Select an option" style="color: #262756;">
          <mat-radio-group  [(ngModel)]="is_active" formControlName="is_active"   >
            <mat-radio-button [value]="0" [checked]="is_active !=1">Bloquer</mat-radio-button> <br>
            <mat-radio-button [value]="1" [checked]="is_active ==1">Débloquer</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="justify-content-end d-flex" style="margin-right: 5%; margin-bottom: 40px;">
  <a
    class="savebtn mr-2"
    type="submit"
    aria-pressed="true"
    (click)="submitFormUpdate(id)"
    >Enregistrer</a
  >

  <a
    class="cancelbtn"
    type="submit"
    aria-pressed="true"
    (click)="closeDialog()"
    >Annuler</a
  >
</div>
